import React from 'react';
import { Zap, Settings2 } from 'lucide-react';
import { useMode } from '../ModeContext';

interface ModeToggleProps {
  className?: string;
}

export function ModeToggle({ className = '' }: ModeToggleProps) {
  const { isQuickMode, isAdvancedMode, toggleMode } = useMode();

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <span
        className={`text-[11px] font-black uppercase tracking-widest transition-colors ${
          isQuickMode ? 'text-accent' : 'text-slate-400'
        }`}
      >
        Quick
      </span>

      <button
        onClick={toggleMode}
        className={`
          relative w-12 h-6 rounded-full transition-all duration-300
          ${isQuickMode
            ? 'bg-accent/20 border border-accent/50 shadow-[0_0_10px_rgba(192, 93, 62,0.2)]'
            : 'bg-emerald-500/20 border border-emerald-500/50 shadow-[0_0_10px_rgba(16,185,129,0.2)]'
          }
          hover:scale-105 active:scale-95 focus:outline-none
        `}
        aria-label={`Switch to ${isQuickMode ? 'Advanced' : 'Quick'} mode`}
      >
        <span
          className={`
            absolute top-0.5 w-4.5 h-4.5 rounded-full transition-all duration-300 flex items-center justify-center
            ${isQuickMode
              ? 'translate-x-0.5 bg-accent'
              : 'translate-x-6 bg-emerald-500'
            }
          `}
          style={{ width: '18px', height: '18px' }}
        >
          {isQuickMode ? (
            <Zap size={10} className="text-slate-950" fill="currentColor" />
          ) : (
            <Settings2 size={10} className="text-slate-950" />
          )}
        </span>
      </button>

      <span
        className={`text-[11px] font-black uppercase tracking-widest transition-colors ${
          isAdvancedMode ? 'text-emerald-500' : 'text-slate-400'
        }`}
      >
        Advanced
      </span>
    </div>
  );
}